export enum DialogueVersionType {
    legacy = 'legacy',
    opiconnectV1 = 'opiconnectV1',
    opiconnectV2 = 'opiconnectV2',
}

export enum ReviewActiveType {
    active = 'active',
    inactive = 'inactive',
    withdrawnByUser = 'withdrawnByUser',
    hiddenByComplaint = 'hiddenByComplaint',
    complaintInProgress = 'complaintInProgress',
    hiddenByAdminPanel = 'hiddenByAdminPanel',
    hiddenByQualityMarkQ = 'hiddenByQualityMarkQ',
}

export enum DialogueResultType {
    closedByUser = 'closedByUser',
    reviewWithdrawnByUser = 'reviewWithdrawnByUser',
    notReadByUser = 'notReadByUser',
    noAgreement = 'noAgreement',
}

export enum ReviewRatingFilters {
    ALL,
    NEGATIVE,
    NEUTRAL,
    POSITIVE,
    CREDIBLE
}

export enum ReviewRatingClass {
    POSITIVE = 'positive',
    NEUTRAL = 'neutral',
    NEGATIVE = 'negative'
}

export enum ReviewQueryParamFilters {
    'pozytywne' = ReviewRatingFilters.POSITIVE,
    'neutralne' = ReviewRatingFilters.NEUTRAL,
    'negatywne' = ReviewRatingFilters.NEGATIVE
}
